import { createAction } from 'redux-actions';
import jsCookie from 'js-cookie';
import { uniqBy } from 'ramda';
import _get from 'lodash/get';
import { selectors as i18nSelectors } from 'mage-i18n';
import { i18nActions } from 'mage-state';

import {
  ON_CHANGE_FORM_VALUE,
  INIT_APP,
  CHANGE_LANGUAGE,
  COOKIES,
  SET_CONFIRMED_COUNTRY_KEY,
  SET_PRODUCTS,
} from '@/constants';

// eslint-disable-next-line no-restricted-imports
import { environmentLanguageConfig, countryLanguageConfig } from '../../translations/config';

const getSetupDataFromCookie = () => jsCookie.getJSON(COOKIES.SETUP_DATA.NAME) || {};

const changeLanguageAction = createAction(CHANGE_LANGUAGE, info => info);
const determineLanguage = (additionalOptions = []) => (dispatch, getState) => {
  const env = _get(window, 'config.common.environment.type');
  const supportedLanguages = environmentLanguageConfig[env] || environmentLanguageConfig.default;

  const currentLanguage = i18nSelectors.language(getState());

  const cookieLanguage = jsCookie.get(COOKIES.ONBOARDING_LANGUAGE.NAME);
  const browserLanguage = navigator.language && navigator.language.substr(0, 2);
  const defaultOptions = [
    { key: 'cookieLanguage', value: cookieLanguage },
    { key: 'browserLanguage', value: browserLanguage },
  ];

  const finalOptions = uniqBy(({ key }) => key, defaultOptions.concat(additionalOptions));
  const supported = finalOptions.filter(({ value }) => supportedLanguages.includes(value));
  const newLanguage =
    supported && supported.length > 0 && supported[0] && supported[0].value
      ? supported[0].value
      : currentLanguage;

  let didUpdate = false;
  if (newLanguage !== currentLanguage) {
    didUpdate = true;
    dispatch(i18nActions.language.set(newLanguage));
  }

  dispatch(
    changeLanguageAction({
      defaultOptions,
      additionalOptions,
      finalOptions,
      supported,
      currentLanguage,
      newLanguage,
      didUpdate,
    }),
  );
};

const onChangeAction = createAction(ON_CHANGE_FORM_VALUE, (key, value) => ({ key, value }));
export const onChangeFormValue = (key, value) => dispatch => {
  // const setupData = getSetupDataFromCookie();
  // setupData[key] = value;
  // const options = {};
  // if (COOKIES.SETUP_DATA.EXPIRES) {
  //   options.expires = COOKIES.SETUP_DATA.EXPIRES;
  // }
  // jsCookie.set(COOKIES.SETUP_DATA.NAME, setupData, options)

  dispatch(onChangeAction(key, value));
};

export const initApp = createAction(INIT_APP, urlParams => {
  const setupData = jsCookie.getJSON(COOKIES.SETUP_DATA.NAME) || {};
  const confirmedCountry = jsCookie.getJSON(COOKIES.CONFIRMED_COUNTRY.NAME) || '';

  if (confirmedCountry) {
    setConfirmedCountryKey(confirmedCountry);
  }

  return {
    resetData: setupData,
    urlParams,
  };
});

export const initLanguage = () => (dispatch, getState) => {
  const setupCookieData = getSetupDataFromCookie() || {};

  const country = setupCookieData.country || '';
  const countryLanguage = countryLanguageConfig[country.toUpperCase()];
  dispatch(determineLanguage([{ key: 'countryLanguage', value: countryLanguage }]));
};

export const setConfirmedCountryKey = createAction(SET_CONFIRMED_COUNTRY_KEY);
export const setConfirmedCountryKeyCreator = value => (dispatch, getState) => {
  // jsCookie.set(COOKIES.CONFIRMED_COUNTRY.NAME, value, {
  //   expires: COOKIES.CONFIRMED_COUNTRY.EXPIRES
  // })
  dispatch(setConfirmedCountryKey(value));
};

export const setProducts = createAction(SET_PRODUCTS);
export const setProductsCreator = value => (dispatch, getState) => {
  dispatch(setProducts(value));
};

export const changeTopbarLanguage = language => (dispatch, getState) => {
  dispatch(determineLanguage());
};
